import { GDFHotPolyRecordNormal } from '../../gdf/type';
import { getCopyButtonComponent } from '../copy-button';

export default function TrackProperties({ record }: { record: GDFHotPolyRecordNormal }) {
    const Button = getCopyButtonComponent();
    return (
        <div>
            <div>Route label: {record.label}</div>
            {Button && (
                <div className="d-flex justify-content-start">
                    <Button getText={() => record.detail} />
                </div>
            )}
            <pre className="p-2 mt-2 secondary-bg-color" style={{ fontFamily: 'monospace' }}>
                {record.detail}
            </pre>
        </div>
    );
}
